import { Link } from 'react-router-dom'
import { FiHome, FiSettings, FiInfo, FiZap, FiDollarSign, FiInstagram, FiMail, FiHelpCircle } from 'react-icons/fi'
import { FaYoutube } from 'react-icons/fa'
import Logo from './Logo'
import { LEGAL } from '../config/legal'

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) {
      const headerOffset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
    }
  }

  const productLinks = [
    { id: 'services', label: 'Serviços', icon: FiSettings },
    { id: 'solutions', label: 'Soluções', icon: FiZap },
    { id: 'pricing', label: 'Planos', icon: FiDollarSign },
    { id: 'faq', label: 'FAQ', icon: FiHelpCircle },
  ]
  const companyLinks = [
    { id: 'home', label: 'Início', icon: FiHome },
    { id: 'about', label: 'Sobre', icon: FiInfo },
    { id: 'contact', label: 'Contato', icon: FiMail },
  ]

  return (
    <footer className="relative bg-gray-100 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 pt-10 sm:pt-12 md:pt-14 pb-8 sm:pb-10 transition-theme">
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-accent/60 to-transparent" aria-hidden="true" />
      <div className="container-custom">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8 w-full min-w-0">
          <div className="sm:col-span-2 lg:col-span-1">
            <button
              onClick={() => scrollToSection('home')}
              className="mb-4 hover:opacity-80 transition-opacity focus:outline-none rounded-lg p-1"
              aria-label="Ir para o início"
            >
              <Logo className="h-10 w-auto" />
            </button>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4 text-sm font-medium">
              Soluções inovadoras em monitoramento de volume para otimizar seus processos industriais.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/sysmv/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full border border-gray-300 dark:border-gray-700 flex items-center justify-center text-gray-700 dark:text-gray-300 hover:bg-accent hover:border-accent hover:text-white hover:scale-110 transition-all duration-300 focus:outline-none"
                aria-label="Instagram"
              >
                <FiInstagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@SysMV"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full border border-gray-300 dark:border-gray-700 flex items-center justify-center text-gray-700 dark:text-gray-300 hover:bg-accent hover:border-accent hover:text-white hover:scale-110 transition-all duration-300 focus:outline-none"
                aria-label="YouTube"
              >
                <FaYoutube className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base font-extrabold text-gray-900 dark:text-white mb-3 sm:mb-4 tracking-tight">
              Produto
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {productLinks.map((link) => {
                const Icon = link.icon
                return (
                  <li key={link.id}>
                    <button
                      onClick={() => scrollToSection(link.id)}
                      className="flex items-center gap-3 text-gray-600 dark:text-gray-300 hover:text-accent dark:hover:text-accent transition-colors group text-sm sm:text-base focus:outline-none rounded-lg py-1"
                    >
                      <Icon className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                      {link.label}
                    </button>
                  </li>
                )
              })}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-extrabold text-gray-900 dark:text-white mb-3 sm:mb-4 tracking-tight">
              Empresa
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {companyLinks.map((link) => {
                const Icon = link.icon
                return (
                  <li key={link.id}>
                    <button
                      onClick={() => scrollToSection(link.id)}
                      className="flex items-center gap-3 text-gray-600 dark:text-gray-300 hover:text-accent dark:hover:text-accent transition-colors group text-sm sm:text-base focus:outline-none rounded-lg py-1"
                    >
                      <Icon className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                      {link.label}
                    </button>
                  </li>
                )
              })}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-extrabold text-gray-900 dark:text-white mb-3 sm:mb-4 tracking-tight">
              Contato
            </h3>
            <ul className="space-y-2 sm:space-y-3 text-gray-600 dark:text-gray-300 text-sm sm:text-base">
              <li>
                <a href={`mailto:${LEGAL.privacyEmail}`} className="hover:text-accent transition-colors focus:outline-none rounded-lg py-1 inline-block">
                  {LEGAL.privacyEmail}
                </a>
              </li>
              <li>{LEGAL.location}</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-gray-200 dark:border-gray-800 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center">
          <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm font-semibold">
            <Link to="/privacidade" className="text-gray-600 dark:text-gray-400 hover:text-accent transition-colors focus:outline-none rounded-lg">
              Política de Privacidade
            </Link>
            <span className="text-gray-300 dark:text-gray-600 hidden sm:inline" aria-hidden>
              |
            </span>
            <Link to="/termos" className="text-gray-600 dark:text-gray-400 hover:text-accent transition-colors focus:outline-none rounded-lg">
              Termos de Uso
            </Link>
          </nav>
          <p className="text-gray-600 dark:text-gray-400 text-xs sm:text-sm font-medium">
            &copy; {new Date().getFullYear()} {LEGAL.brand}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
